/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import testCropDev from 'data/generic_crops_dev.json';

const BASE_URL = 'https://nutriguide-python-dev.azurewebsites.net/api';
const API_KEY = '0aQfPoNKVF7s3kSkg6KqJsXHzBKN4jqdC45xsQ1Bb4Gp6/PU/z4dbw==';

export const GTM_HEAD = `
  <!-- Google Tag Manager -->
  <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-K482VD2');</script>
  <!-- End Google Tag Manager -->`;

export const GTM_BODY = `
  <!-- Google Tag Manager (noscript) -->
  <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-K482VD2"
  height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
  <!-- End Google Tag Manager (noscript) -->`;

export const FACEBOOK_PIXEL_SCRIPT = false;
export const FACEBOOK_PIXEL_NOSCRIPT = false;

const AZURE_ENDPOINTS = {
  user: '/user',
  cropList: '/cropList',
  organicFertilizerList: '/organicfertilizerList',
  soilList: '/soilList',
  soilComposition: '/soilcomposition',
  postPlan: '/plan',
  planList: '/planList',
  deletePlan: '/plan',
  cityList: '/cityList',
  getTerms: '/terms',
  getOrganisation: '/organisation',
  generic: '/generic/test/',
  genericCropList: '/generic/crop',
  genericOrganicFertilizerList: '/generic/organicFertilizer',
  genericOrganicFertilizer: '/generic/organicFertilizer',
  genericPlan: '/generic/plan',
};

export const AZURE_AD_B2C_CONFIG = {
  clientID: '90653122-a6fc-4c46-978f-1ea80aebe500',
  signInUp_authority:
    'https://cclatb2c.b2clogin.com/cclatb2c.onmicrosoft.com/B2C_1_DEV_Nutriguide_SiUpIn',
  resetPassword_authority:
    'https://cclatb2c.b2clogin.com/cclatb2c.onmicrosoft.com/B2C_1_DEV_Nutriguide_SSPR_modern',
};

const GOOGLE_MAPS_API_KEY = 'AIzaSyCB_RXBHL01AcLCd8-_O9A0YqvnBpYRj0A';

function encodeQueryData(data) {
  const ret = [];
  for (const d in data) ret.push(`${encodeURIComponent(d)}=${encodeURIComponent(data[d])}`);
  return ret.join('&');
}

function createEnvURL(endpoint) {
  return BASE_URL + AZURE_ENDPOINTS[endpoint];
}

export const getUrl = (endpoint, input, pathComponents) => {
  let url = createEnvURL(endpoint);
  if (pathComponents) {
    url += pathComponents;
  }
  url += `?code=${API_KEY}`;
  if (input && endpoint !== 'deletePlan') {
    url += `&${encodeQueryData(input)}`;
  }
  return url;
};

export const getRestResource = (route, input) => {
  let url = BASE_URL;
  url += route;
  url += `?code=${API_KEY}`;
  if (input) url += `&${encodeQueryData(input)}`;
  return url;
};

export const googleMapApiKey = () => GOOGLE_MAPS_API_KEY;
export const borealisPageUrl = () => 'https://lat-web-dev.azurewebsites.net/';
export const borealisImageStore = () => 'https://latwebdevteststorage.blob.core.windows.net/blobcloudstorage/';
export const nutriguideStorageURL = () => 'https://nutriguidepythondev.blob.core.windows.net';

export const getGTMHead = () => GTM_HEAD;
export const getGTMBody = () => GTM_BODY;
export const getFacebookPixelScript = () => FACEBOOK_PIXEL_SCRIPT;
export const getFacebookPixelNoScript = () => FACEBOOK_PIXEL_NOSCRIPT;

const DATA_ENVIRONMENT_AZURE_DEV = 'azure-dev';
const DATA_ENVIRONMENT_PKCALCULATOR = 'pkcaculator';

const DATA_ENVIRONMENT = DATA_ENVIRONMENT_AZURE_DEV;
export const isLive = () => DATA_ENVIRONMENT === DATA_ENVIRONMENT_PKCALCULATOR;
export const getTestCropData = () => testCropDev;
